import script from "./cashWheel.vue?vue&type=script&setup=true&lang=ts"
export * from "./cashWheel.vue?vue&type=script&setup=true&lang=ts"

import "./cashWheel.vue?vue&type=style&index=0&id=a9f5ad02&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9f5ad02"]])

export default __exports__